var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "login-page-container",
      attrs: { a_id: "logout-container", "extension-name": "logout-page" }
    },
    [
      _c(
        "div",
        {
          staticClass: "login-page-header login-page-header-center",
          attrs: { a_id: "login-page-header" }
        },
        [
          _vm.isTargetAgent
            ? _c("span", { staticClass: "login-page-header-text" }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm._f("translate")("LoginPage.AgentLogin")) +
                    "\n\t\t"
                )
              ])
            : _c("span", { staticClass: "login-page-header-text" }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm._f("translate")("LogoutPage.LoginHeaderStart")) +
                    " "
                ),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm._f("translate")("LoginPage.LoginHeaderEnd"))
                  )
                ])
              ])
        ]
      ),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "logout-page-reason" }, [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm._f("translate")("LogoutPage.Reason")) +
              "\n\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "logout-page-reason" }, [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm._f("translate")("LogoutPage.Action")) +
              "\n\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "login-page-footer logout-page-footer",
          attrs: { a_id: "login-page-footer" }
        },
        [
          _c(
            "button",
            {
              staticClass: "login-page-footer-button-center",
              attrs: { a_id: "login-page-footer-login-button" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.loginBtnHandler($event)
                }
              }
            },
            [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(_vm._f("translate")("LoginPage.LoginButton")) +
                  "\n\t\t"
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4b376c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4b376c0","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/LogoutPage.vue
// module id = 458
// module chunks = 0